"use client";

import { getSlug, imageFallback } from "@shared/utils";
import { Card, CardContent, CardFooter, CardHeader } from "@ubud-ui/react-ui-kit";
import Image from "next/image";
import Link from "next/link";
import { Company } from "../types";

type CompanyCardProps = {
  company: Company;
  onClick?: (company: Company) => void;
};
export function CompanyCard({ company, onClick }: CompanyCardProps) {
  const handleClick = () => {
    if (onClick) {
      onClick(company);
    }
  };

  return (
    <>
      <Card className="w-full h-full bg-white border border-gray-200 rounded-xl flex flex-col justify-between relative overflow-hidden shadow-none">
        <div>
          <CardHeader className="p-4 flex items-start justify-between flex-row">
            <Image
              src={company.logoUri || "/blank-white.webp"}
              alt={company.name || company.industryName}
              width="60"
              height="60"
              className="size-14 xl:size-[60px] bg-white border border-grey-200 rounded-lg object-contain"
              onError={imageFallback()}
            />
          </CardHeader>
          <CardContent className="p-4">
            <div className="max-h-24 overflow-hidden flex flex-col gap-0.5">
              <h4 className="font-bold text-base overflow-hidden max-h-[48px]">
                <Link href={`/perusahaan/${getSlug(company.id, company.name)}`} onClick={handleClick} className="hover:text-primary">
                  {company.name}
                </Link>
              </h4>
              <p className="font-normal text-base truncate">{company.industryName}</p>
            </div>
          </CardContent>
        </div>
        <CardFooter className="px-4 pb-4 block">
          <p className="text-xs font-normal text-gray-500 truncate mt-1">{company.cityName}</p>
        </CardFooter>
      </Card>
    </>
  );
}
